export default __webpack_public_path__ + "1c15239e573627933e4e781884bd7c5b.wav";